/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unstable-nested-components */
import React, { Component } from 'react';
import { AutoSizer, Table, Column } from 'react-virtualized';
import { Icon, Modal } from 'semantic-ui-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import closeBtn from '../../images/common/close-btn.svg';
import './TabRowInputComponent.css';

class TabRowInputComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchVersion: '',
      searchFileName: '',
      searchIdentifier: '',
      searchScanPath: '',
      isOpenMoreInfo: false,
      scanPathArray: [],
    };
    this.clearSearch = this.clearSearch.bind(this);
    this.handleChangeIdentifiers = this.handleChangeIdentifiers.bind(this);
    this.handleChangeVersion = this.handleChangeVersion.bind(this);
    this.handleChangeFileName = this.handleChangeFileName.bind(this);
    this.handleChangeScanPath = this.handleChangeScanPath.bind(this);
    this.handleIdentifiersKeyPress = this.handleIdentifiersKeyPress.bind(this);
    this.handleVersionKeyPress = this.handleVersionKeyPress.bind(this);
    this.handleFileNameKeyPress = this.handleFileNameKeyPress.bind(this);
    this.handleScanPathKeyPress = this.handleScanPathKeyPress.bind(this);
    this.searchFileNameString = this.searchFileNameString.bind(this);
    this.updateSearchValue = this.updateSearchValue.bind(this);
    this.handleMoreInfo = this.handleMoreInfo.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const { isOpenMoreInfo } = this.state;
    this.updateSearchValue();
    if (isOpenMoreInfo) {
      this.setState({
        isOpenMoreInfo: false,
        scanPathArray: [],
      });
    }
  }

  handleChangeIdentifiers = (event) => {
    this.setState({ searchIdentifier: event.target.value });
  };

  handleChangeVersion = (event) => {
    this.setState({ searchVersion: event.target.value });
  };

  handleChangeFileName = (event) => {
    this.setState({ searchFileName: event.target.value });
  };

  handleChangeScanPath = (event) => {
    this.setState({ searchScanPath: event.target.value });
  };

  handleIdentifiersKeyPress(event) {
    if (event.key === 'Enter') {
      this.searchUniqueString(event.target.value);
    }
  }

  handleVersionKeyPress(event) {
    if (event.key === 'Enter') {
      this.searchVersionString(event.target.value);
    }
  }

  handleFileNameKeyPress(event) {
    if (event.key === 'Enter') {
      this.searchFileNameString(event.target.value);
    }
  }

  handleScanPathKeyPress(event) {
    if (event.key === 'Enter') {
      this.searchScanPathString(event.target.value);
    }
  }

  handleMoreInfo(dataArray) {
    this.setState({
      isOpenMoreInfo: true,
      scanPathArray: dataArray,
    });
  }

  searchUniqueString = (value) => {
    const { matchesData, currentIndex, updateUniqueCallback } = this.props;
    const newData = {};

    // eslint-disable-next-line no-unused-vars
    Object.entries(matchesData).forEach(([key, lists]) => {
      lists.forEach((list) => {
        if (list.unique_string.toLowerCase().includes(value.toLowerCase())) {
          if (!newData[list.version]) {
            newData[list.version] = [];
          }
          newData[list.version].push(list);
        }
      });
    });

    const obj = {
      type: 'unique_string',
      backup_data: matchesData,
      update_data: newData,
      value,
      index: currentIndex,
    };

    updateUniqueCallback(obj);
  };

  searchVersionString = (value) => {
    const { matchesData, currentIndex, updateUniqueCallback } = this.props;
    const newData = {};

    // eslint-disable-next-line no-unused-vars
    Object.entries(matchesData).forEach(([key, lists]) => {
      lists.forEach((list) => {
        if (list.version.toLowerCase().includes(value.toLowerCase())) {
          if (!newData[list.version]) {
            newData[list.version] = [];
          }
          newData[list.version].push(list);
        }
      });
    });

    const obj = {
      type: 'version',
      backup_data: matchesData,
      update_data: newData,
      value,
      index: currentIndex,
    };

    updateUniqueCallback(obj);
  };

  searchFileNameString = (value) => {
    const { matchesData, currentIndex, updateUniqueCallback } = this.props;
    const newData = {};

    // eslint-disable-next-line no-unused-vars
    Object.entries(matchesData).forEach(([key, lists]) => {
      lists.forEach((list) => {
        if (list.crawled_file.toLowerCase().includes(value.toLowerCase())) {
          if (!newData[list.version]) {
            newData[list.version] = [];
          }
          newData[list.version].push(list);
        }
      });
    });

    const obj = {
      type: 'crawled_file',
      backup_data: matchesData,
      update_data: newData,
      value,
      index: currentIndex,
    };

    updateUniqueCallback(obj);
  };

  searchScanPathString = (value) => {
    const { matchesData, currentIndex, updateUniqueCallback } = this.props;
    const newData = {};

    Object.entries(matchesData).forEach(([key, lists]) => {
      lists.forEach((list) => {
        if (Array.isArray(list.scanned_file)) {
          const filteredPaths = list.scanned_file.filter((path) => { return path.toLowerCase().includes(value.toLowerCase()); });

          if (filteredPaths.length > 0) {
            if (!newData[list.version]) {
              newData[list.version] = [];
            }
            newData[list.version].push({ ...list, scanned_file: filteredPaths });
          }
        }
      });
    });

    const obj = {
      type: 'scanned_file',
      backup_data: matchesData,
      update_data: newData,
      value,
      index: currentIndex,
    };

    updateUniqueCallback(obj);
  };

  copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  updateSearchValue() {
    const {
      uniqueStringValue, versionValue, fileNameValue, currentIndex, setActiveValue, scanPathValue
    } = this.props;
    if (uniqueStringValue !== '') {
      this.setState({ searchIdentifier: uniqueStringValue });
    }

    if (versionValue !== '') {
      this.setState({ searchVersion: versionValue });
    }

    if (fileNameValue !== '') {
      this.setState({ searchFileName: fileNameValue });
    }

    if (scanPathValue !== '') {
      this.setState({ searchScanPath: scanPathValue });
    }

    if (localStorage.getItem('matched_detail') === null) {
      this.setState({
        searchIdentifier: '',
        searchVersion: '',
        searchFileName: '',
        searchScanPath: '',
      });
    }
    setActiveValue(currentIndex, 'unique_matches');
  }

  clearSearch() {
    const { clearDetailedSearch } = this.props;
    if (localStorage.getItem('matched_detail') !== null) {
      this.setState({
        searchIdentifier: '',
        searchVersion: '',
        searchFileName: '',
        searchScanPath: '',
      });
      return clearDetailedSearch('unique_matches');
    }
    this.setState({
      searchIdentifier: '',
      searchVersion: '',
      searchFileName: '',
      searchScanPath: '',
    });
  }

  closeModal() {
    this.setState({
      isOpenMoreInfo: false,
      scanPathArray: [],
    });
  }

  arrayToTableCell(dataArray) {
    const { translate } = this.props;
    const visibleItems = dataArray.slice(0, 3);
    const isMore = dataArray.length > 3 || visibleItems.some((item) => { return item.length > 30; });

    return (
      <span>
        <ul>
          {
            visibleItems.map((item, index) => {
              return (
                <li key={index}>
                  <Icon name="copy outline" onClick={() => { return this.copyToClipboard(item); }} style={{ cursor: 'pointer' }} />
                  {item}
                </li>
              );
            })
          }
        </ul>
        {
          isMore && (
            <li className="more_info">
              <span
                onClick={() => { return this.handleMoreInfo(dataArray); }}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') this.handleMoreInfo(dataArray); }}
                tabIndex={0}
                role="button"
              >
                {translate('list.title.more_info')}
              </span>
            </li>
          )
        }
      </span>
    );
  }

  render() {
    const {
      matchesData,
      translate,
      versionCount,
      crawledFileNameCount,
      lineNumberCount,
      scannedFileNameCount,
      componentCount,
    } = this.props;
    const {
      searchVersion,
      searchFileName,
      searchIdentifier,
      searchScanPath,
      isOpenMoreInfo,
      scanPathArray,
    } = this.state;

    let flattenedData = Object.keys(matchesData).reduce((acc, version) => {
      const items = matchesData[version].map((item) => { return { ...item, version }; });
      return acc.concat(items);
    }, []);

    flattenedData = [{ isInputRow: true, id: 'inputRow-0' }, ...flattenedData];

    return (
      <div style={{ height: '500px' }}>
        <AutoSizer>
          {({ width, height }) => {
            return (
              <Table
                width={width}
                height={height}
                headerHeight={25}
                rowHeight={80}
                rowCount={flattenedData.length}
                rowGetter={({ index }) => { return flattenedData[index]; }}
              >
                <Column
                  label="Version"
                  dataKey="version"
                  width={90}
                  headerRenderer={() => {
                    return (
                      <div>
                        {`${translate('list.title.version')}(${versionCount})`}
                      </div>
                    );
                  }}
                  cellRenderer={({ cellData, rowData }) => {
                    if (rowData.isInputRow) {
                      return (
                        <div className="row_saerch_wrap">
                          <input
                            className="text"
                            style={{ lineHeight: '28px', height: '28px', fontSize: '12px' }}
                            value={searchVersion}
                            placeholder={translate('list.title.version')}
                            onChange={this.handleChangeVersion}
                            onKeyPress={this.handleVersionKeyPress}
                          />
                          <a
                            className="reset_icon"
                            onClick={this.clearSearch}
                            onKeyUp={this.clearSearch}
                          >
                            x
                          </a>
                        </div>
                      );
                    }
                    return (
                      <div className="table-cell-wrapper">
                        <Icon name="copy outline" onClick={() => { return this.copyToClipboard(rowData.version); }} style={{ cursor: 'pointer' }} />
                        <span className="table-cell">{rowData.version}</span>
                      </div>
                    );
                  }}
                />
                <Column
                  label={translate('list.title.file_name')}
                  dataKey="unique_string"
                  width={170}
                  headerRenderer={() => {
                    return (
                      <span>
                        {`${translate('list.title.identifiers')}(${componentCount})`}
                      </span>
                    );
                  }}
                  cellRenderer={({ cellData, rowData, rowIndex }) => {
                    if (rowData.isInputRow) {
                      return (
                        <div className="row_saerch_wrap">
                          <input
                            className="text"
                            style={{ lineHeight: '28px', height: '28px', fontSize: '12px' }}
                            value={searchIdentifier}
                            placeholder={translate('list.title.identifiers')}
                            onKeyPress={this.handleIdentifiersKeyPress}
                            onChange={this.handleChangeIdentifiers}
                          />
                          <a
                            className="reset_icon"
                            onClick={this.clearSearch}
                            onKeyUp={this.clearSearch}
                          >
                            x
                          </a>
                        </div>
                      );
                    }
                    return (
                      <div className="table-cell-wrapper">
                        <Icon name="copy outline" onClick={() => { return this.copyToClipboard(rowData.unique_string); }} style={{ cursor: 'pointer' }} />
                        <span className="table-cell">{rowData.unique_string}</span>
                      </div>
                    );
                  }}
                />
                <Column
                  label={translate('list.title.matched_crawled_file_name')}
                  dataKey="crawled_file"
                  width={140}
                  headerRenderer={() => {
                    return (
                      <span>
                        {`${translate('list.title.matched_crawled_file_name')}(${crawledFileNameCount})`}
                      </span>
                    );
                  }}
                  cellRenderer={({ cellData, rowData, rowIndex }) => {
                    if (rowData.isInputRow) {
                      return (
                        <div className="row_saerch_wrap">
                          <input
                            className="text"
                            style={{ lineHeight: '28px', height: '28px', fontSize: '12px' }}
                            value={searchFileName}
                            placeholder={translate('list.title.matched_crawled_file_name')}
                            onKeyPress={this.handleFileNameKeyPress}
                            onChange={this.handleChangeFileName}
                          />
                          <a
                            className="reset_icon"
                            onClick={this.clearSearch}
                            onKeyUp={this.clearSearch}
                          >
                            x
                          </a>
                        </div>
                      );
                    }
                    return (
                      <div className="table-cell-wrapper">
                        <Icon name="copy outline" onClick={() => { return this.copyToClipboard(rowData.crawled_file); }} style={{ cursor: 'pointer' }} />
                        <span className="table-cell">{rowData.crawled_file}</span>
                      </div>
                    );
                  }}
                />
                <Column
                  label={translate('list.title.line_no')}
                  dataKey="line_numbers"
                  width={90}
                  headerRenderer={() => {
                    return (
                      <span>
                        {`${translate('list.title.line_no')}(${lineNumberCount})`}
                      </span>
                    );
                  }}
                  cellRenderer={({ cellData, rowData }) => {
                    if (rowData.isInputRow) {
                      return (<div />);
                    }
                    return (
                      <div className="table-cell-wrapper">
                        <Icon name="copy outline" onClick={() => { return this.copyToClipboard(rowData.line_numbers); }} style={{ cursor: 'pointer' }} />
                        <span className="table-cell">{rowData.line_numbers}</span>
                      </div>
                    );
                  }}
                />
                <Column
                  label={translate('list.title.matched_scanned_file_name')}
                  dataKey="scanned_file"
                  width={170}
                  headerRenderer={() => {
                    return (
                      <span>
                        {`${translate('list.title.matched_scanned_file_name')}(${scannedFileNameCount})`}
                      </span>
                    );
                  }}
                  cellRenderer={({ cellData, rowData }) => {
                    if (rowData.isInputRow) {
                      return (
                        <div className="row_saerch_wrap">
                          <input
                            className="text"
                            style={{ lineHeight: '28px', height: '28px', fontSize: '12px' }}
                            value={searchScanPath}
                            placeholder={translate('list.title.matched_scanned_file_name')}
                            onKeyPress={this.handleScanPathKeyPress}
                            onChange={this.handleChangeScanPath}
                          />
                          <a
                            className="reset_icon"
                            onClick={this.clearSearch}
                            onKeyUp={this.clearSearch}
                          >
                            x
                          </a>
                        </div>
                      );
                    }
                    return (
                      <div className="table-cell-wrapper extracted_file">
                        {
                          rowData.scanned_file.length !== 0 ? (
                            <span className="table-cell">{this.arrayToTableCell(rowData.scanned_file)}</span>
                          ) : (
                            <span className="table-cell" />
                          )
                        }
                      </div>
                    );
                  }}
                />
              </Table>
            );
          }}
        </AutoSizer>
        <Modal
          className="scan_path_list"
          open={isOpenMoreInfo}
          onClose={this.closeModal}
        >
          <div className="modal_popup_wrap file_info_wrap">
            <div className="modal_popup_box file_info_box">
              <div className="modal_popup file_info">
                <h2 className="title">
                  <span>
                    {translate('list.title.matched_scanned_file_list')}
                  </span>
                  <a className="close_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                    <img src={closeBtn} alt="" />
                  </a>
                </h2>
                <Scrollbars
                  renderTrackHorizontal={() => {
                    return <div />;
                  }}
                  renderThumbHorizontal={() => {
                    return <div />;
                  }}
                  style={{ height: '470px' }}
                >
                  <div className="popup_content">
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                      {scanPathArray.map((item, index) => {
                        return (
                          <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                            <Icon name="copy outline" onClick={() => { return this.copyToClipboard(item); }} style={{ cursor: 'pointer', marginRight: 5 }} />
                            {item}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </Scrollbars>
                <div className="button_wrap">
                  <a onClick={this.closeModal} onKeyUp={this.closeModal} className="center_button">{translate('modal.button.close')}</a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default TabRowInputComponent;
